module.exports = __webpack_public_path__ + "static/media/kronos.3442cecc.png";